import React from "react";
import style from "./index.module.scss";
import { Checkbox, Radio } from "antd";
import StuAnswerSub from "../StuAnswerSub";
import StuAnswerObj from "../StuAnswerObj";
import {
    BaseQuestionType,
    BaseQuestionTypeMap,
    viewPaperListItem
} from "service/exercise";

interface TopicReviewProps {
    data: viewPaperListItem;
    index: number | string;
    exerciseId: string;
    studentNo: string;
    onOk: () => void;
}

export default function TopicReview({
    data,
    index,
    exerciseId,
    studentNo,
    onOk
}: TopicReviewProps) {
    const type: BaseQuestionType = data.queTypeId;

    return (
        <div className={style.root}>
            <div className={style.info}>
                <em>{index}.</em>（
                {data.typeName ? data.typeName : BaseQuestionTypeMap[type]}，
                {data.score ? data.score : 0}分）
                {/*教师是否批阅 1:已批阅, 0:未批阅*/}
                {data.teacherMark === "0" && (
                    <span className={style.todo}>待批阅</span>
                )}
            </div>

            <div className={style.trunk}>
                <div
                    className={style.title}
                    dangerouslySetInnerHTML={{ __html: data.contentText }}
                />
            </div>

            <div className={style.options}>
                {/* 单选项 */}
                {data.queTypeId === BaseQuestionType.SingleChoice && (
                    <Radio.Group disabled>
                        {data.options.map(item => (
                            <Radio
                                className={style.option}
                                value={item.id}
                                key={item.id}
                                checked={String(item.id) === data.stuAns}>
                                <div className={style.index}>
                                    {item.serialNum}.
                                </div>
                                <div
                                    className={style.optionInner}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </Radio>
                        ))}
                    </Radio.Group>
                )}

                {/* 多选项 */}
                {data.queTypeId === BaseQuestionType.MultipleChoice &&
                    data.options.map(item => (
                        <Checkbox
                            disabled
                            className={style.option}
                            value={item.id}
                            key={item.id}
                            checked={data.stuAns?.includes(item.id + "")}>
                            <div className={style.index}>{item.serialNum}.</div>
                            <div
                                className={style.optionInner}
                                dangerouslySetInnerHTML={{
                                    __html: item.description
                                }}
                            />
                        </Checkbox>
                    ))}
            </div>

            {data.queTypeId <= 5 &&
                data.queTypeId !== BaseQuestionType.Subjective && (
                    <StuAnswerObj
                        score={data.score}
                        stuScore={data.stuScore}
                        stuIsRight={data.stuIsRight}
                        stuAns={data.stuAns}
                        options={data.options}
                        queTypeId={data.queTypeId}
                    />
                )}

            {data.queTypeId === BaseQuestionType.Subjective && (
                <StuAnswerSub
                    score={data.score}
                    analysis={data.analysis}
                    stuAns={data.stuAns}
                    questionId={data.id}
                    exerciseId={exerciseId}
                    studentNo={studentNo}
                    stuScore={data.stuScore}
                    teacherComment={data.teacherComment}
                    onOk={onOk}
                />
            )}
        </div>
    );
}
